<div *ngIf="firstLoading" class="comp-loader">
	<lib-loading></lib-loading>
</div>
<div *ngIf="!firstLoading && profile" class="broker_profile">
  <app-broker-header *ngIf="profile"
    [profile]="profile">
  </app-broker-header>
  <div class="broker_profile_body"
    [class.broker_profile_body_no_content]="!searchContent?.length && !loadingProducts">

    <div class="broker_profile_body_btns">
      <div class="broker_profile_body_btns_container">
        <div class="broker_profile_body_btns_container_btns"
          [class.filter_no_content]="!searchContent.length">
          <lps-search-order
            *ngIf="searchContent.length"
            class="lps-search-order"
            [notMarginRight]="true"
            [order]="order"
            (orderChange)="changeOrder($event)">
          </lps-search-order>
    
          <lps-search-filter-wrapper
            [showOperationType]="true"
            (filterHasChanged)="getBrokerProducts()">
          </lps-search-filter-wrapper>
        </div>
      </div>
    </div>

    <div class="has_content" *ngIf="!!(searchContent?.length || loadingProducts); else noContent">
      <div class="has_content_header">

        <p class="has_content_header_description">
          <span class="has_content_header_description_hello">Olá!</span> <br/>
          {{ searchSummary?.formatted }}
        </p>
        
      </div>

      <lps-card-grid
        [target]="'_blank'"
        [hideBookmark]="true"
        [loading]="loadingProducts"
        [productCards]="searchContent"
        [theme]="'broker'"
        [productBaseLink]="uriProduct"
        [showSwiper]="true"
        [numberSkeletons]="4"
        [nickname]="profile.nickname">
      </lps-card-grid>

      <div class="has_content_pagination"
        *ngIf="totalElements">
        <nz-pagination
          [(nzPageIndex)]="pageIndex"
          [nzTotal]="totalElements"
          [nzSize]="'small'"
          [(nzPageSize)]="pageSize"
          (nzPageIndexChange)="navigate($event)">
        </nz-pagination>
      </div>
    </div>

    <ng-template #noContent>
      <div class="no_content">
        <h2>;(</h2>
        <h2>Nenhum imóvel encontrado.</h2>
      </div>
    </ng-template>
  </div>

  <footer class="broker_profile_footer">
    <p>
      {{ year }} Copyright - LPS SÃO PAULO CONSULTORIA DE IMÓVEIS LTDA - CRECI 024073-J - CNPJ 15.673.605/0001-10  -  Todos os direitos reservados
    </p>
  </footer>
  
</div>